export default {"src":"/_next/static/media/modernization.fffe9d38.svg","height":25,"width":25};